import { useEffect, useState } from 'react';
import { getCollaboratorProfiles } from '../../utils/mindmap/apiClient';
import { normalizeCollaboratorPicture } from '../../utils/mindmap/collaborators';

const EMPTY = Object.freeze({});
export default function useCollaboratorProfiles({ mapId, accountId, enabled, userIds }) {
  const key = JSON.stringify([...new Set(userIds)].sort().slice(0, 100));
  const [state, setState] = useState({ mapId: null, accountId: null, profiles: EMPTY });
  useEffect(() => {
    if (!enabled || !mapId || !accountId) return undefined;
    let active = true;
    let timer;
    let firstRefresh = true;
    const controller = new AbortController();
    const requested = JSON.parse(key);
    async function refresh() {
      try {
        const result = await getCollaboratorProfiles(mapId, requested, { signal: controller.signal });
        if (!active) return;
        const profiles = {};
        for (const profile of result.profiles || []) {
          if (requested.includes(profile.userId)) profiles[profile.userId] = normalizeCollaboratorPicture(profile.pictureUrl);
        }
        setState(previous => previous.mapId === mapId && previous.accountId === accountId
          && JSON.stringify(previous.profiles) === JSON.stringify(profiles)
          ? previous : { mapId, accountId, profiles });
      } catch {
        // Identity and presence remain available from validated awareness;
        // use initials whenever the optional picture lookup fails.
        if (active) setState({ mapId, accountId, profiles: EMPTY });
      } finally {
        if (active) {
          timer = setTimeout(refresh, firstRefresh ? 2000 : 15000);
          firstRefresh = false;
        }
      }
    }
    void refresh();
    return () => { active = false; clearTimeout(timer); controller.abort(); };
  }, [mapId, accountId, enabled, key]);
  return enabled && state.mapId === mapId && state.accountId === accountId ? state.profiles : EMPTY;
}
